<template>
        <div>
                 <el-dialog
                        title="充值明细"
                        width="65%"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        充值明细
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 250px);overflow:scroll">
                        <div style="padding-bottom: 20px;font-size: 20px;font-weight: bold;">
                                车牌号:{{plateNumber}}
                        </div>
                        <avue-crud
                                :option="option"
                                :table-loading="loading"
                                :data="data"
                                :page.sync="page"
                                @current-change="currentChange"
                                @size-change="sizeChange"
                                @refresh-change="onLoad"
                                @on-load="onLoad"
                                ref="crud"
                        >
                                <template slot="tradeFee" slot-scope="scope">
                                        {{tool.money_format_allowvoid(scope.row.tradeFee)}}
                                </template>
                                <template slot="oldBalance" slot-scope="scope">
                                        {{tool.money_format_allowvoid(scope.row.oldBalance)}}
                                </template>
                        </avue-crud>

                </div>
                </el-dialog>
        </div>
</template>
<script>
import {
    getrRchargeList
  } from '@/api/v4ward/park/storedValueCarv2/storedValueCar';
export default {
        props:{
                projectList:{
                        type:Array,
                        default(){
                                return []
                        }
                }
        },
        data(){
                return{
                        loading:false,
                        data:[],
                        dialogVisible:false,
                        dialogFull:false,
                        plateNumber:'',
                        page: {
                                pageSize: 10,
                                currentPage: 1,
                                total: 0,
                        },
                        option:{
                                tip: true,
                                searchShow: true,
                                searchMenuSpan: 6,
                                border: true,
                                addBtn: true,
                                viewBtn: false,
                                menu:false,
                                add_carMonthBtn: true,
                                selection: false,
                                selectionClearBtn:true,
                                dialogClickModal: false,
                                labelWidth: 120,
                                columnBtn: true,
                                refreshBtn: true,
                                stripe:true,
                                header:false,
                                index:true,
                                height:'auto',
                                column:[
                                        {
                                                label:'充值金额',
                                                prop:'tradeFee',
                                                slot:true,
                                                align:'right',

                                        },
                                        {
                                                label:'支付方式',
                                                prop:'payType',

                                        },
                                        {
                                                label:'操作人',
                                                prop:'operatePerson'

                                        },
                                        {
                                                label:'操作时间',
                                                prop:'createTime'

                                        }
                                ]
                        }

                }
        },
        created(){
                this.option.height = this.bodyHeight - 400
        },
        methods:{
                openDialog(row){
                        this.plateNumber = row.plateNumber;
                        this.query = {
                                parkingLotId:row.spaceId,
                                vehicleId:row.id,
                        }
                        this.dialogVisible = true;
                        this.onLoad();
                        // this.initData(row.id,type);
                },
                async initData(id,type){


                        this.loading = false;
                },
                currentChange(currentPage) {
                        this.page.currentPage = currentPage;
                },
                sizeChange(pageSize) {
                        this.page.pageSize = pageSize;
                },
                refreshTable() {
                        this.onLoad();
                },
                onLoad(page) {
                        page = page || this.page;
                        this.loading = true;
                        getrRchargeList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
                                ({ data }) => {
                                        this.page.total = data.total;
                                        this.data = data.records;
                                        this.loading = false;

                                },
                        ).catch(res=>{
                                 this.loading = false;
                        })
                },
        }
}
</script>
